import { YourFavoriteApi } from "@/api";

export async function get() {
  const { data } = await YourFavoriteApi.get();
  return data;
}
